
















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { SelectItem } from "@/types";

@Component
export default class BasicInfo6 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() beppyou_items!: SelectItem[]; //別表選択アイテムリスト

  @Emit("openDialog")
  openDialog() {
    return;
  }
}
